<p-dialog *ngIf="device" [(visible)]="device" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '50vw' }">
	<ng-template pTemplate="header">
		<div class="d-flex">
			<fa-icon [icon]="['far', 'mobile-screen']" class="me-4" size="2x"></fa-icon>
			<div class="display-8 ms-1 my-auto">FocusPay Device Management</div>
		</div>
		<p-divider></p-divider>
	</ng-template>

	<div class="p-grid">
		<div class="p-col-12 p-md-6 d-flex flex-column">
			<span class="p-float-label mt-4">
				<p-dropdown
					#deviceTypeSelect
					[options]="app.references.focusPayDeviceTypes"
					optionLabel="label"
					optionValue="value"
					name="deviceTypeSelect"
					[(ngModel)]="device.type"
					[style]="{ width: '100%' }"
					appendTo="body"
					[autoDisplayFirst]="false"
					[virtualScroll]="true"
					virtualScrollItemSize="30"
					filter="true"
					(filterBy)="app.keys(app.references.focusPayDeviceTypes)"
					(onChange)="changesToSave = true; deviceTypeSetImage()"
				></p-dropdown>
				<label for="deviceTypeSelect">Device Type</label>
			</span>
			<span class="p-float-label mt-4">
				<input pInputText #deviceKeyInput name="deviceKeyInput" type="text" [(ngModel)]="device.key" class="w-100" (change)="changesToSave = true" />
				<label for="deviceKeyInput">Serial Number</label>
			</span>
		</div>
		<div class="p-col-12 p-md-6">
			<div class="mx-auto my-auto">
				<img width="auto" [src]="deviceImage" height="150px" />
			</div>
		</div>
	</div>
	<p-divider></p-divider>
	<div class="p-grid mt-4">
		<div class="p-col-12 p-md-6 d-flex flex-column">
			<p-button
				*ngIf="userService.userSubscription.value.role >= 5 && !device.dealerKey"
				pRipple
				styleClass="p-button-raised p-button-secondary m-2"
				(click)="assignToDealer = !assignToDealer"
			>
				<ng-template pTemplate="content">
					<div class="d-flex justify-content-center">
						<fa-icon [icon]="['far', 'user-tie']" size="lg" class="ms-1 me-2"></fa-icon>
						Assign to Dealer
					</div>
				</ng-template>
			</p-button>
			<span class="p-float-label" *ngIf="assignToDealer || (device.dealerKey && userService.userSubscription.value.role >= 5)">
				<p-dropdown
					#dealerSelect
					[options]="dealerService.dealerList.value"
					optionLabel="name"
					optionValue="key"
					name="dealerSelect"
					[(ngModel)]="device.dealerKey"
					[style]="{ width: '100%' }"
					appendTo="body"
					[autoDisplayFirst]="false"
					[virtualScroll]="true"
					virtualScrollItemSize="30"
					filter="true"
					(filterBy)="app.keys(dealerService.dealerList.value)"
					(onChange)="dealerListChange(); changesToSave = true"
				></p-dropdown>
				<label for="dealerSelect">Dealer</label>
			</span>
		</div>
		<div class="p-col-12 p-md-6 d-flex flex-column">
			<p-button
				*ngIf="userService.userSubscription.value.role >= 3 && !device.venueKey"
				pRipple
				styleClass="p-button-raised p-button-secondary m-2"
				(click)="assignToVenue = !assignToVenue"
				[disabled]="assignToDealer && !device.dealerKey"
			>
				<ng-template pTemplate="content">
					<div class="d-flex justify-content-center">
						<fa-icon [icon]="['far', 'store']" size="lg" class="ms-1 me-2"></fa-icon>
						Assign to Venue
					</div>
				</ng-template>
			</p-button>
			<span class="p-float-label" *ngIf="assignToVenue || (device.venueKey && userService.userSubscription.value.role >= 3)">
				<p-dropdown
					#venueSelect
					[options]="venueList"
					optionLabel="venueName"
					optionValue="venueKey"
					name="venueSelect"
					[(ngModel)]="device.venueKey"
					[style]="{ width: '100%' }"
					appendTo="body"
					[autoDisplayFirst]="false"
					[virtualScroll]="true"
					virtualScrollItemSize="30"
					filter="true"
					(filterBy)="app.keys(venueList)"
					(onChange)="deviceVenueChange(); changesToSave = true"
				></p-dropdown>
				<label for="venueSelect">Venue</label>
			</span>
		</div>
	</div>

	<ng-template pTemplate="footer">
		<app-record-control-footer
			(onCancelChange)="this.deviceChange.emit(undefined); this.device = undefined"
			(onDeleteChange)="onDelete()"
			(onSaveChange)="onSave()"
			[deleteDisabled]="this.userService.userSubscription.value.role < 5"
			[saveDisabled]="!this.device.key || !this.device.type || !this.changesToSave"
		></app-record-control-footer>
	</ng-template>
</p-dialog>
